import React, { useCallback, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

const EditableField = ({ label, value, onChange, options, name, type = 'text', ...props }) => {
  return (
    <div className="field">
      <div style={{ display: 'flex', flexDirection: 'column', }}>
        <>{label}{' '}</>
        {type === 'text' && (
          <InputText name={name} value={value} onChange={onChange} {...props} />
        )}
        {type === 'calendar' && (
          <Calendar
            value={new Date(value)}
            onChange={onChange}
            name={name}
            {...props}
          />
        )}
        {type === 'dropdown' && (
          <Dropdown
            value={value}
            options={options}
            onChange={(e) => onChange({ target: { name, value: e.value } })}
            placeholder={`Select a ${label}`}
            filter
            {...props}
          />
        )}
        {type === 'number' && (
            <InputNumber
              name={name}
              value={value}
              onValueChange={(e) => onChange({ target: { name, value: e.value } })}
              mode="decimal"
              minFractionDigits={2}
              useGrouping={false}
              {...props}
            />
          )}
      </div>
    </div>
  );
}

const NonEditableField = ({ label, value }) => (
  <div className="field">
    <strong><label>{label}</label></strong>
    <div>{value}</div>
  </div>
);

export { EditableField, NonEditableField };